<template>
  <div
    v-if="src"
    class="fixed inset-0 z-[60] bg-black/90 flex items-center justify-center"
    role="dialog"
    aria-modal="true"
    :aria-label="alt"
    @click="$emit('close')"
  >
    <img
      :src="src"
      :alt="alt"
      class="max-w-full max-h-full object-contain select-none"
      @click.stop
    />

    <button
      type="button"
      class="absolute top-4 right-4 w-12 h-12 rounded-full bg-white/90 hover:bg-white text-neutral-800 flex items-center justify-center shadow-lg"
      aria-label="Закрыть"
      @click.stop="$emit('close')"
    >
      <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>

    <p class="absolute bottom-4 left-0 right-0 text-center text-white/80 text-sm">
      Нажмите на фон или Esc, чтобы вернуться к работе
    </p>
  </div>
</template>

<script>
/**
 * Просмотр изображения на весь экран (Z-50 по встрече 21.08.2026).
 *
 * Фото и инструкции на рабочих столах выводятся мелко, и рассмотреть их было нечем.
 * Просмотрщик ничего не делает с текущей операцией: он только рисуется поверх,
 * закрывается по фону, крестику и Esc и возвращает оператора туда же, где он был.
 *
 * @see resources/js/pages/workPlace/WorkPlaceIndex.vue
 */
export default {
  name: 'FullscreenImageViewer',
  props: {
    /** Адрес изображения; пустое значение просмотрщик не показывает */
    src: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: 'Изображение',
    },
  },
  emits: ['close'],
  watch: {
    src: {
      immediate: true,
      handler(value) {
        if (value) {
          document.addEventListener('keydown', this.onKeydown);
        } else {
          document.removeEventListener('keydown', this.onKeydown);
        }
      },
    },
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.onKeydown);
  },
  methods: {
    onKeydown(event) {
      if (event.key === 'Escape') {
        this.$emit('close');
      }
    },
  },
};
</script>
